
//
import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import VueMeta from 'vue-meta';
import LogRocket from 'logrocket';
// import VModal from 'vue-js-modal';

//start logging
try {
	LogRocket.init('tr2dcj/armslist-deals');
}catch(e) {}

//
Vue.use(VueMeta, { refreshOnceOnNavigation: true });
// Vue.use(VModal, { dynamic: true });


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
});